/** Pixel height of the fixed enterprise admin top bar (CourseraHeader in admin). */
export const ENTERPRISE_ADMIN_NAVBAR_HEIGHT_PX = 66;
